module.exports = __webpack_public_path__ + "media/fonts/POPLARSTD-69a2b1c22846f9931a582e5e82e02700.OTF";